import { useTranslation } from "react-i18next";
import {
  useAuthentication,
  useRetrieveCurrentPlanzone,
  useRetrieveResourcesListingConfiguration,
  useRetrieveSecondaryCriteriaTemplate,
} from "@planzone/view-models";

const fixedColumns = [
  "tags",
  "role",
  "invitationStatus",
  "subordinates",
  "organizationalUnit",
];

function useResourcesListingColumns() {
  const { t, i18n } = useTranslation();
  const { account } = useAuthentication();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { configuration } = useRetrieveResourcesListingConfiguration(planzone);
  const { template } = useRetrieveSecondaryCriteriaTemplate(
    planzone.uuid,
    "resource",
  );
  const currentLang =
    ["fr", "en"].find((lang) => new RegExp(lang, "i").test(i18n.language)) ||
    "fr";
  const role = account.resource?.role;
  const matchedProfile = configuration.find(
    (profile) =>
      !!role && profile.roles.find((r) => r === role.name || r === role.uuid),
  );
  const columns = matchedProfile
    ? matchedProfile.columns.filter(
        ({ key }) =>
          fixedColumns.includes(key) ||
          template.find(({ uuid }) => uuid === key),
      )
    : [];

  return {
    columns,
    label: (key: string) => {
      const criteria = template.find(({ uuid }) => uuid === key);

      return criteria
        ? criteria.labels[currentLang as keyof typeof criteria.labels] ||
            criteria.name
        : t(`planzoneMembersPage.resources.${key}`, key);
    },
  };
}

export { useResourcesListingColumns };
